// extracted by mini-css-extract-plugin
module.exports = {"search-page":"UserAdminPage-search-page--37k5c","errors":"UserAdminPage-errors--3NxrZ","danger":"UserAdminPage-danger--1nvxR"};